export default [
  'favorites',
  'cart',
  'goto',
  'macsima',
  'ds',
  'rdposter',
  'oauth',
  'oauth',
  'sitemap.xml',
  'imagesitemap.xml',
  'buildSitemap.xml',
  'buildImageSitemap.xml',
  'media/thumbnail*',
  'neos',
  'miltenyi-endpoints',
  'mpuptest',
  'mpup-oauth',
  'mpup-print-unit-inventory'
]
